import { string, object } from 'yup'

export const CreateRegionValidator = object().shape({
    name: string().required('Region name is required').min(1).max(50),
})
